import { createFileRoute } from '@tanstack/react-router'
import { ConsentScreen } from '@/components/oauth/ConsentScreen'
import { searchSchema } from './consent.schema'

export const Route = createFileRoute('/oauth/consent')({
  validateSearch: (search) => searchSchema.parse(search),
  component: RouteComponent,
})

function RouteComponent() {
  const { authorization_id } = Route.useSearch()
  return <ConsentScreen authorizationId={authorization_id} />
}
